import React from 'react'
import { BsCheck } from 'react-icons/bs';
import Select from "react-select";
import { customStyles } from '../../util/FormatUtil';
import PhoneInput from "react-phone-number-input";

const CustomPhone = (props) => {

    // console.log('props in CustomSelect', props)

    return (
        <div className={props.fromFilterPage ? "form-group row pr-1" : "form-group row"}>
            {props.fromFilterPage ? (
                <fieldset className='col-12 col-md-10 p-2' style={props.hideNullFilter ? { position: 'relative' } : {}}>
                    <legend id={props.label} style={{ fontSize: "0.8em" }} className={"pt-1 px-1 font-weight-bold"}>
                        {props.label}
                    </legend>

                    <div className={props.hideNullFilter ? "col-12 pl-md-0" : "col-8 pl-md-0"} id={props.label}>
                        <PhoneInput
                            id={props.label}
                            placeholder="Enter phone # (10 digit)"
                            onChange={(e) => {
                                props.handleDateOnChange(e)
                            }}
                            defaultCountry="US"
                            value={props.value}
                            aria-label={props.label.replaceAll(' ', '') + "Filter"}
                        />
                    </div>
                    {!props.hideNullFilter && <div className="d-none d-lg-inline col-lg-2"></div>}
                    {!props.hideNullFilter && <div className="col-2 col-md-1">
                        {props.value || props.nullValue ? (<BsCheck className={"float-right"} color={"#21212E"} size={20} />) : null}
                    </div>}
                    {props.hideNullFilter && (props.value || props.nullValue) && (
                        <BsCheck style={{ position: 'absolute', top: 0, right: 0 }} color={"#21212E"} size={20} />
                    )}
                    {!props.hideNullFilter && <div className="col-12 pl-0 pr-1">
                        <div className="row mt-1">
                            <div className="col-12">
                                <Select
                                    styles={customStyles}
                                    isMulti={true}
                                    isSearchable={true}
                                    placeholder={<div className="accessibilityText">Select...</div>}
                                    aria-label={props.label.replaceAll(' ', '') + "Filter"}
                                    onChange={(e) => {
                                        props.handleChange(e)
                                    }}
                                    className={"state_select"}
                                    options={props.options}
                                    value={props.nullValue}
                                />
                            </div>
                        </div>
                    </div>}
                </fieldset>
            ) : (
                <>
                    <div className="col-12 col-md-4" data-toggle={"tooltip"} data-placement={"top"} title={props.tooltip}>
                        <label htmlFor={props.label.replaceAll(' ', '')} style={{ fontWeight: "bold", paddingTop: "0.5em", fontSize: "0.8em" }}>
                            {props.label}
                        </label>
                    </div>
                    <div className="col-12 col-md-8 pl-md-0 pr-md-1" id={props.label}>
                        <fieldset style={{ border: 'none', padding: 0, margin: 0 }}>
                            <legend className="sr-only">{props.label}</legend>
                            <PhoneInput
                                id={props.label.replaceAll(' ', '')}
                                placeholder="Enter phone # (10 digit)"
                                onChange={(e) => {
                                    props.handleDateOnChange(e)
                                }}
                                defaultCountry="US"
                                value={props.value}
                                aria-label={props.label.replaceAll(' ', '')}
                            />
                        </fieldset>
                    </div>
                </>
            )}
        </div>
    )
}

export default CustomPhone